import DOMPurify from 'dompurify';

/** DOMPurify options for rich HTML (tables, inline styles, legacy tags). */
const RICH_HTML_DOM_PURIFY: Parameters<typeof DOMPurify.sanitize>[1] = {
  ADD_TAGS: [
    'style',
    'link',
    'font',
    'center',
    'pre',
    's',
    'strike',
    'u',
    'tbody',
    'thead',
    'tfoot',
    'colgroup',
    'col',
  ],
  ADD_ATTR: [
    'style',
    'target',
    'rel',
    'media',
    'width',
    'height',
    'class',
    'border',
    'cellpadding',
    'cellspacing',
    'align',
    'valign',
    'bgcolor',
    'background',
    'color',
    'size',
    'face',
    'dir',
    'colspan',
    'rowspan',
    'scope',
    'abbr',
    'axis',
    'headers',
    'nowrap',
    'frame',
    'rules',
    'summary',
  ],
  RETURN_DOM_FRAGMENT: true,
};

function stripScripts(html: string): string {
  if (!html) return html;
  let out = html.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, '');
  out = out.replace(/<noscript\b[^>]*>[\s\S]*?<\/noscript>/gi, '');
  const div = document.createElement('div');
  div.innerHTML = out;
  div.querySelectorAll('*').forEach((el) => {
    Array.from(el.attributes).forEach((attr) => {
      if (/^on\w+/i.test(attr.name) || (attr.name === 'formaction' && /^\s*javascript:/i.test(attr.value))) {
        el.removeAttribute(attr.name);
      }
    });
    const href = el.getAttribute('href');
    if (href && /^\s*javascript:/i.test(href)) el.removeAttribute('href');
  });
  return div.innerHTML;
}

function domPurifyRichToInnerHtml(dirty: string): string {
  const purified: unknown = DOMPurify.sanitize(dirty, RICH_HTML_DOM_PURIFY);
  const outDiv = document.createElement('div');
  if (purified instanceof DocumentFragment) {
    outDiv.appendChild(purified);
  } else if (typeof purified === 'string') {
    outDiv.innerHTML = purified;
  }
  return outDiv.innerHTML;
}

/** Sanitize custom/pasted HTML for rich editors (signatures, quoted blocks, etc.). */
export function sanitizeRichEmailHtml(html: string): string {
  if (!html?.trim()) return '';
  return stripScripts(domPurifyRichToInnerHtml(html.trim()));
}
